/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CountRemoteSessionsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CountRemoteSessionsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CountRemoteSessionsSecurity = {
  option1?: CountRemoteSessionsSecurityOption1 | undefined;
  option2?: CountRemoteSessionsSecurityOption2 | undefined;
};

export type CountRemoteSessionsRequest = {
  /**
   * The remote_session_client whose sessions to count.
   */
  remoteSessionClientId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type CountRemoteSessionsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CountRemoteSessionsSecurityOption1$outboundSchema: z.ZodMiniType<
  CountRemoteSessionsSecurityOption1$Outbound,
  CountRemoteSessionsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function countRemoteSessionsSecurityOption1ToJSON(
  countRemoteSessionsSecurityOption1: CountRemoteSessionsSecurityOption1,
): string {
  return JSON.stringify(
    CountRemoteSessionsSecurityOption1$outboundSchema.parse(
      countRemoteSessionsSecurityOption1,
    ),
  );
}

/** @internal */
export type CountRemoteSessionsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CountRemoteSessionsSecurityOption2$outboundSchema: z.ZodMiniType<
  CountRemoteSessionsSecurityOption2$Outbound,
  CountRemoteSessionsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function countRemoteSessionsSecurityOption2ToJSON(
  countRemoteSessionsSecurityOption2: CountRemoteSessionsSecurityOption2,
): string {
  return JSON.stringify(
    CountRemoteSessionsSecurityOption2$outboundSchema.parse(
      countRemoteSessionsSecurityOption2,
    ),
  );
}

/** @internal */
export type CountRemoteSessionsSecurity$Outbound = {
  Option1?: CountRemoteSessionsSecurityOption1$Outbound | undefined;
  Option2?: CountRemoteSessionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CountRemoteSessionsSecurity$outboundSchema: z.ZodMiniType<
  CountRemoteSessionsSecurity$Outbound,
  CountRemoteSessionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CountRemoteSessionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CountRemoteSessionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function countRemoteSessionsSecurityToJSON(
  countRemoteSessionsSecurity: CountRemoteSessionsSecurity,
): string {
  return JSON.stringify(
    CountRemoteSessionsSecurity$outboundSchema.parse(
      countRemoteSessionsSecurity,
    ),
  );
}

/** @internal */
export type CountRemoteSessionsRequest$Outbound = {
  remote_session_client_id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const CountRemoteSessionsRequest$outboundSchema: z.ZodMiniType<
  CountRemoteSessionsRequest$Outbound,
  CountRemoteSessionsRequest
> = z.pipe(
  z.object({
    remoteSessionClientId: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      remoteSessionClientId: "remote_session_client_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function countRemoteSessionsRequestToJSON(
  countRemoteSessionsRequest: CountRemoteSessionsRequest,
): string {
  return JSON.stringify(
    CountRemoteSessionsRequest$outboundSchema.parse(countRemoteSessionsRequest),
  );
}
